var AppDispatcher = require('../dispatcher/app-dispatcher');
var Constants = require('../constants/global');

var UserServerActions = {

  loginRequired: placeId => {
    AppDispatcher.handleServerAction({
      actionType: Constants.LOGIN_REQUIRED,
      id: placeId
    });
  },

  loginSuccessful: placeId => {
    AppDispatcher.handleServerAction({
      actionType: Constants.LOGIN_SUCCESSFUL,
      id: placeId
    });
  }
    
};

module.exports = UserServerActions;



// WEBPACK FOOTER //
// ./actions/user-server-actions.js